import { render, staticRenderFns } from "./ViewDetailKanji.vue?vue&type=template&id=19b350b1&scoped=true&"
import script from "./ViewDetailKanji.vue?vue&type=script&lang=js&"
export * from "./ViewDetailKanji.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailKanji.vue?vue&type=style&index=0&id=19b350b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b350b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
